import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Observable, from, map } from 'rxjs';
import { CognitoService } from './cognito.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private _cognitoService: CognitoService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    
    // Obtener el token de acceso del servicio de autenticación guardado en localStorage
    const rbacToken = localStorage.getItem('rbac-token') as string;

    // Convert the promise to an observable using `from`
    return from(this._cognitoService.getUser()).pipe(
      map((user: any) => {
        if (user && rbacToken) {
          // User is authenticated and has valid data
          return true;
        } else {
          // User data is null or doesn't meet the conditions, redirect to login
          this.router.navigate(['auth', 'login']);
          return false;
        }
      })
    );
  }
}
